<div class="text-modal">
  <div class="text-modal-dialog">
    <div class="text-modal-content">
      <div class="text-modal-content__header">{{ title }}</div>

      <div class="text-modal-content__body">
        <div class="text-modal-textarea">
          <textarea #textArea [formControl]="text" [placeholder]="placeholder"
            [attr.maxlength]="maxLength"></textarea>
        </div>
        <div class="text-modal-counter">{{ length }}/{{ maxLength }}</div>
      </div>

      <div class="text-modal-content__footer">
        <button type="button" class="text-modal-button clear" *ngIf="value" (click)="clear()">Clear</button>
        <button type="button" class="text-modal-button cancel" (click)="cancel()">Cancel</button>
        <button type="button" class="text-modal-button done" (click)="done()">Done</button>
      </div>
    </div>
  </div>
</div>
